const linkRegex =
  /^(?!.*\s)(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:www\.\S+|(?:(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:\S+(?:\/[^\s/]+)*)?(?:\/?)(?:\S+\.\S+))$/

export { linkRegex }
